import Browse from '../components/browse/index';
import Layout from '../components/layouts/allpagelayout';

const BrowsePage = () => {
  return (
    <Layout>
      <Browse />
    </Layout>
  );
}       
export default BrowsePage;